import { UiSocialProofModel } from "../../models";

import {
    mock$AssetModel,
    mockAdfDocument,
    mockAdfParagraph,
    mockAdfText,
    mockUiImageModel,
    mockUiImageModelContent
} from "./";

export function mockUiSocialProofModel({
    id = "SocialProof-1234",
    type = "uiSocialProof",
    locale = "en",
    content = mockUiSocialProofModelContent()
}: Partial<UiSocialProofModel> = {}): UiSocialProofModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiSocialProofModelContent = UiSocialProofModel["content"];

export function mockUiSocialProofModelContent({
    entryTitle = "Women Who Code",
    customerQuote = mockAdfDocument({
        content: [
            mockAdfParagraph({
                content: [
                    mockAdfText({
                        text: "[Trello is] great for simplifying complex processes. As a manager, I can chunk [processes] down into bite-sized pieces for my team and then delegate that out, but still keep a bird's-eye view"
                    })
                ]
            })
        ]
    }),
    customerDetails = "Global Leadership Director at Women Who Code",
    customerLogoImage = mockUiImageModel({
        content: mockUiImageModelContent({
            image: mock$AssetModel({
                url: "/ui-social-proof/women-who-code.svg"
            })
        })
    }),
    customerName = "Joey Rosenberg",
    productFact = "75% of organizations report that Trello delivers value to their business within 30 days.",
    background = uiSocialProofBackground("P300", "WP300"),
    ...optionals
}: Partial<UiSocialProofModelContent> = {}): UiSocialProofModelContent {
    return {
        entryTitle,
        customerQuote,
        customerDetails,
        customerLogoImage,
        customerName,
        productFact,
        background,
        ...optionals
    };
}

function uiSocialProofBackground(color: string, gradient: string) {
    return [
        {
            breakpoints: ["xs", "sm", "md", "lg", "xl"],
            color,
            properties: [
                {
                    attachment: "scroll",
                    blendMode: "normal",
                    clip: "border-box",
                    image: {
                        type: "gradient",
                        image: {
                            id: "",
                            value: "none"
                        },
                        gradient: {
                            value: gradient,
                            angle: 60
                        }
                    },
                    origin: "padding-box",
                    position: {
                        fieldType: "units",
                        keywords: {
                            horizontal: "left",
                            vertical: "top"
                        },
                        units: {
                            unit: "%",
                            horizontal: 0,
                            vertical: 0
                        }
                    },
                    repeat: "repeat",
                    size: {
                        fieldType: "keyword",
                        keyword: "auto",
                        units: {
                            unit: "%",
                            width: 100,
                            height: 100,
                            isAutoWidth: false,
                            isAutoHeight: false
                        }
                    }
                }
            ]
        }
    ];
}
